import JiaMengHeader from '@components/JiaMeng/Header/Order'
import React from 'react'
import { asyncLoad } from '@util'

const AsyncOrderManage = asyncLoad(() =>
  import('@components/LocalMerchant/OrderManage_new/Tab')
)
const AsyncOrderDetail = asyncLoad(() =>
  import('@components/LocalMerchant/OrderManage_new/Detail')
)
const AsyncJiaMengWeddingOrder = asyncLoad(() =>
  import('@components/JiaMeng/WeddingOrder')
)
export default {
  path: 'orderManage_new',
  component: props => <JiaMengHeader key="orderManage_new" {...props} />,
  indexRoute: {
    component: AsyncOrderManage
  },
  stat: '订单管理/首页',
  childRoutes: [
    {
      path: ':tab', // TODO，这个路由定义导致不能使用二级，只能用三级
      component: AsyncOrderManage
    },
    {
      path: 'detail/:id',
      component: AsyncOrderDetail,
      stat: '订单管理/订单详情'
    },
    {
      path: 'wedding/list',
      component: AsyncJiaMengWeddingOrder
    }
  ]
}
